<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="load">刷新</Button>
          </Col>
          <Col span="5">
<!--            <Input search enter-button placeholder="输入关键词搜索" v-model="serch.key"  @on-search="load"/>-->
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="PP_NAME" label="课程名称" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="SP_ADDRESS" label="开课地点" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="SP_STIME" label="开课时间" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="msg" label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <a @click="showQian(scope.row)">查看签到列表</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save"
      @on-cancel="cancel">
      <Form :label-width="80">
        <FormItem label="编号">
          <Input v-model="detail.id"/>
        </FormItem>
        <FormItem label="课程编号">
          <Input v-model="detail.spid"/>
        </FormItem>
        <FormItem label="报名cpid">
          <Input v-model="detail.cpid"/>
        </FormItem>
        <FormItem label="公司名称">
          <Input v-model="detail.cname"/>
        </FormItem>
        <FormItem label="姓名">
          <Input v-model="detail.ctname"/>
        </FormItem>
        <FormItem label="手机号">
          <Input v-model="detail.phone"/>
        </FormItem>

      </Form>
    </Modal>

    <Drawer :title="m2.title" width="750" v-model="m2.modal">
      <el-table :border="1" :data="m2.list" size="small" style="width: 100%" >
<!--        <el-table-column prop="id" label="编号" :show-tooltip-when-overflow="true"></el-table-column>-->
<!--        <el-table-column prop="spid" label="课程编号" :show-tooltip-when-overflow="true"></el-table-column>-->
<!--        <el-table-column prop="cpid" label="报名cpid" :show-tooltip-when-overflow="true"></el-table-column>-->
        <el-table-column prop="cname" label="公司名称" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="ctname" label="姓名" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="ctime" label="签到时间" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="phone" label="手机号" :show-tooltip-when-overflow="true"></el-table-column>
      </el-table>
    </Drawer>


  </div>
</template>

<script>
export default {
  data(){
    return{
      baseUrl:'/api/qiandao/',
      list:[],
      page:1,
      count:0,
      limit:10,
      modal1:false,
      detail:{},
      serch:{
        key:''
      },
      loading:false,
      m2:{
        modal:false,
        list:[],
        title:'',
      }
    }
  },
  methods:{
    showQian(item){
      console.log(item);
      this.m2.title = item.PP_NAME+" "+item.SP_ADDRESS+" "+item.SP_STIME;

      let that = this;
      let params = ['t.spid@=@'+item.SP_ID];
      this.$axios.get(this.baseUrl+'findall?page=1&limit=1000&params='+params).then(function(rs){
        that.m2.list = rs.data.data;
        that.m2.modal = true;
      });

    },
    load(){
      let that = this;
      let params = [];
      if(this.serch.key){
        params.push('t.id@=@'+this.serch.key);
      }
      that.loading = true;
      this.$axios.get(this.baseUrl+'getQiandaoList?page='+this.page+"&limit=10").then(function(rs){
        that.list = rs.data.data;
        that.count = rs.data.count;
        that.loading = false;
      });
    },
    limitChange(val){
      this.limit = val;
      this.load();
    },
    change(val){
      this.page = val;
      this.load();
    },
    save(){
      let that = this;
      let data = Object.assign({}, this.detail);
      this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
        that.toast(rs.data);
        if(rs.data.success){
          that.detail = {};
        }
      });
    },
    edit(id){
      let that = this;
      this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
        that.detail = rs.data;
        that.modal1 = true;
      });
    },
    remove(id){
      this.$Modal.confirm({
        title: '系统提示',
        content: '确定要删除吗',
        onOk: () => {
          let that = this;
          this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
            that.toast(rs.data);
          });
        },
      });
    },
    toast(data){
      if(data.success){
        this.load();
        this.$Message.success(data.msg);
      }else{
        this.$Message.error(data.msg);
      }
    }
  },
  created(){
    this.load();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/qiandao/Qiandao.vue